import {Component, OnInit} from '@angular/core';
import {GlobalService} from '../service/global.service';
import {ModalService} from '../service/modal.service';
import {UtilApi} from '../service/api/util.api';

@Component({
    selector: 'app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})

export class AppComponent implements OnInit {

    constructor(public globalService: GlobalService, private utilApi: UtilApi, public modalService: ModalService) {
    }

    ngOnInit(): void {
        this.utilApi.invocacaoRemotaComRetry(5, 1000, this, AppComponent.prototype.carregarConf);
    }

    carregarConf() {
        this.globalService.carregarConf();
    }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts